import * as React from 'react';
import ProfileMain from '../../components/profile/ProfileMain';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function Profile() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])

  return (
    <ProfileMain></ProfileMain>
  );
}